export enum EnergyContentUnit {
    MJKG = 'MJKG',
}

export interface EnergyContentMessage {
    value: number;
    unit: EnergyContentUnit.MJKG;
}
